import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Dropdown from "reactstrap/lib/Dropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownItem from "reactstrap/lib/DropdownItem";
import ChevronDefaultRight from "@druva-apps/orion-icons/lib/ChevronsmallrightGreyOutline";

import {
  gatherConditionalProps,
  isFunction,
  hasProperty
} from "../../lib/utils";
import "./dropdownSelect.scss";

const getMaxHeight = props => {
  return String(props.maxMenuHeight).endsWith("px")
    ? props.maxMenuHeight
    : `${props.maxMenuHeight}px`;
};

class DropdownSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  dropdownItemClicked = item => {
    const { onItemClick, callback } = this.props;

    onItemClick(item);

    if (isFunction(callback)) {
      callback();
    }
  };

  render() {
    const { isActive, disabled, disabledTrigger, label, rightAligned } =
      this.props;
    const { dropdownOpen } = this.state;
    return (
      <Dropdown
        nav
        inNavbar
        className="oui-dropdown-select"
        active={isActive}
        isOpen={dropdownOpen}
        toggle={this.toggle}
      >
        <DropdownToggle
          nav
          className="oui-dropdown-select-toggle"
          disabled={disabled || disabledTrigger}
        >
          {label}&nbsp;
          <ChevronDefaultRight
            inheritFontColor
            size="xs"
            width={11}
            height={11}
            muted={false}
            className="oui-dropdown-caret"
          />
        </DropdownToggle>
        <DropdownMenu
          right={rightAligned}
          style={{ maxHeight: getMaxHeight(this.props), overflowY: "auto" }}
        >
          {this.renderDropdownItems()}
        </DropdownMenu>
      </Dropdown>
    );
  }

  renderDropdownItems = () => {
    const { items } = this.props;

    return items.map((item, index) => {
      if (hasProperty(item, "divider")) {
        return this.renderDivider(index);
      }
      if (hasProperty(item, "heading")) {
        return this.renderHeadingItems(item, index);
      }
      return this.renderItem(item, index);
    });
  };

  renderDivider = index => <DropdownItem divider key={index} />;

  renderHeadingItems = (headingItem, index) => {
    return (
      <Fragment key={`fg-${index}`}>
        <DropdownItem header key={`header-${index}`}>
          {headingItem.heading}
        </DropdownItem>
        {headingItem.items.map((item, ind) => {
          return this.renderItem(item, `header-${index}-${ind}`);
        })}
      </Fragment>
    );
  };

  renderItem = (item, index) => {
    const { label } = this.props;
    const { href, target } = item;
    const linkProps = {};
    if (href) {
      linkProps.href = href;
      if (target) {
        linkProps.target = target;
      }
    }

    return isFunction(item.renderComponent) ? (
      item.renderComponent(item, index, null, "oui-dropdown-item")
    ) : (
      <DropdownItem
        key={index}
        active={item.label === label}
        {...gatherConditionalProps(item, "disabled", "onClick")}
        {...linkProps}
        onClick={() => {
          this.dropdownItemClicked(item);
        }}
      >
        {isFunction(item.label) ? item.label(item) : item.label}
      </DropdownItem>
    );
  };
}

DropdownSelect.propTypes = {
  items: PropTypes.array,
  onItemClick: PropTypes.func,
  callback: PropTypes.func,
  label: PropTypes.string,
  maxMenuHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledTrigger: PropTypes.bool,
  rightAligned: PropTypes.bool
};

DropdownSelect.defaultProps = {
  items: [],
  onItemClick: () => {},
  maxMenuHeight: 320
};

DropdownSelect.displayName = "OrionDropdownSelect";

export default DropdownSelect;
